import billingOrder from "~/schemas/schema.billingOrder.jsx";
import * as actionTypes from "~/store/action_types";
import { getBillingOrderProperty } from "~/store/selectors/selector.billingOrder.jsx";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchBillingOrder = () => {
  return {
    types: [
      actionTypes.FETCH_BILLING_ORDER_LOADING,
      actionTypes.FETCH_BILLING_ORDER_SUCCESS,
      actionTypes.FETCH_BILLING_ORDER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/order`,
      }),
    payload: {
      schema: {
        single: billingOrder,
      },
    },
  };
};

export const editBillingOrder = (attributes) => {
  return {
    types: [
      actionTypes.EDIT_BILLING_ORDER_LOADING,
      actionTypes.EDIT_BILLING_ORDER_SUCCESS,
      actionTypes.EDIT_BILLING_ORDER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/order`,
        method: `PUT`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: billingOrder,
      },
    },
  };
};

export const completeBillingOrder = () => (dispatch, getState) => {
  let billing_order_type = getBillingOrderProperty(getState(), `type`);
  let complete_order_url = getBillingOrderProperty(getState(), `complete_order_url`);

  return dispatch({
    types: [
      actionTypes.COMPLETE_BILLING_ORDER_LOADING,
      actionTypes.COMPLETE_BILLING_ORDER_SUCCESS,
      actionTypes.COMPLETE_BILLING_ORDER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}${complete_order_url}`,
        method: `POST`,
      }),
    payload: {
      billing_order_type,
    },
  });
};

export const closeBillingOrderProcessingScreen = () => {
  return {
    type: actionTypes.CLOSE_BILLING_ORDER_PROCESSING_SCREEN,
  };
};

export const setBillingOrderStep = (step) => {
  return {
    type: actionTypes.SET_BILLING_ORDER_STEP,
    step,
  };
};

export const fetchThankYou = () => {
  return {
    types: [
      actionTypes.FETCH_THANK_YOU_LOADING,
      actionTypes.FETCH_THANK_YOU_SUCCESS,
      actionTypes.FETCH_THANK_YOU_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/thank-you`,
      }),
  };
};
